// create_investor_area
export const CREATE_INVESTOR_AREA = 'create_investor_area';
export const CREATE_INVESTOR_AREA_SUCCESSFUL =
  'create_investor_area_successfull';
export const CREATE_INVESTOR_AREA_FAILED = 'create_investor_area_failed';

// get_investor_worldwideShares
export const GET_INVESTOR_WORDWIDESHARES = 'get_investor_worldwideShares';
export const GET_INVESTOR_WORDWIDESHARES_SUCCESSFUL =
  'get_investor_worldwideShares_successfull';
export const GET_INVESTOR_WORDWIDESHARES_FAILED =
  'get_investor_worldwideShares_failed';

// update_investor_area
export const UPDATE_INVESTOR_AREA = 'update_investor_area';
export const UPDATE_INVESTOR_AREA_SUCCESSFUL =
  'update_investor_area_successfull';
export const UPDATE_INVESTOR_AREA_FAILED = 'update_investor_area_failed';

// delete_investor_area
export const DELETE_INVESTOR_AREA = 'delete_investor_area';
export const DELETE_INVESTOR_AREA_SUCCESSFUL =
  'delete_investor_area_successfull';
export const DELETE_INVESTOR_AREA_FAILED = 'delete_investor_area_failed';
